/**
 * Formata uma data com hora no formato localizado
 * @param {string|Date} dateValue - Data a ser formatada (string ISO ou objeto Date)
 * @param {string} locale - Locale para formatação (padrão: 'pt-BR')
 * @returns {string} Data formatada no formato "dd/MM/yyyy HH:mm"
 */
export const formatDateTime = (dateValue, locale = 'pt-BR') => {
  if (!dateValue) return '';

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const dateStr = date.toLocaleDateString(locale);
  const timeStr = date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${dateStr} ${timeStr}`;
};
